import { FieldPath } from 'react-hook-form'
import i18n from 'i18next'
import i18next from 'i18next'
import { RadioOption } from '@microservices/wiskey-react-components/dist/hookFormControllers/RadioGroupController'
import { ColumnDef } from '@tanstack/react-table'

import { GETAction, GETEntityColumn, TimeLineGridConfig } from '@types'

import { BIND_TYPE } from './tables'

export const TIME_LINE_COLUMN_WIDTH = 250

export const TIME_LINE_URL_SIZE = 100

export const BOTTOM_PINNED_TOTAL_ROW_ID = 'bottom_pinned_total_row_id'

export const TIME_LINE_GROUP_PREFIX = 'time_line_group_'

export enum TIME_LINE_MODE {
  DATE_TIME = 'DATE_TIME',
  OBJECT = 'OBJECT',
}

const enum INCREMENT_TYPE {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export enum TIME_LINE_OBJECTS_LINK {
  DIRECT = 'DIRECT',
  THROUGH_OBJECT = 'THROUGH_OBJECT',
}

export const TIME_LINE_CREATE_OR_EDIT_STEPS = [
  i18n.t('timeLinesCreateOrEdit.tab.general'),
  i18n.t('timeLinesCreateOrEdit.tab.objectY'),
  i18n.t('timeLinesCreateOrEdit.tab.objectX'),
  i18n.t('timeLinesCreateOrEdit.tab.mainObject'),
]

export const TIME_LINE_OBJECT_X_CELL_BIND_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIME_LINE_OBJECT_X_HEADER_BIND_TYPES = [
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.FIELD, label: BIND_TYPE.FIELD },
]

export const TIME_LINE_MAIN_OBJECT_GROUP_TITLE_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIME_LINE_MODE_AUTOCOMPLETE_OPTIONS = [
  { id: TIME_LINE_MODE.DATE_TIME, label: TIME_LINE_MODE.DATE_TIME },
  { id: TIME_LINE_MODE.OBJECT, label: TIME_LINE_MODE.OBJECT },
]

export const TIME_LINE_OBJECTS_LINK_AUTOCOMPLETE_OPTIONS = [
  { id: TIME_LINE_OBJECTS_LINK.DIRECT, label: TIME_LINE_OBJECTS_LINK.DIRECT },
  { id: TIME_LINE_OBJECTS_LINK.THROUGH_OBJECT, label: TIME_LINE_OBJECTS_LINK.THROUGH_OBJECT },
]

export const TIME_LINE_OBJECT_TOTAL_ROW_BIND_TYPES = [
  { id: BIND_TYPE.JSX, label: BIND_TYPE.JSX },
  { id: BIND_TYPE.JS, label: BIND_TYPE.JS },
]

export const TIMELINE_COLUMNS: ColumnDef<GETEntityColumn>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewColumnsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewColumnsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'bindType',
    header: i18next.t('viewColumnsTable.bindType'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'value',
    header: i18next.t('viewColumnsTable.value'),
    meta: { flex: 1 },
  },
]

export const TIMELINE_OBJECT_X_COLUMNS: ColumnDef<GETEntityColumn>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewColumnsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewColumnsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'bindType',
    header: i18next.t('viewColumnsTable.bindType'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'value',
    header: i18next.t('viewColumnsTable.value'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'pinnedColumn',
    header: i18next.t('viewColumnsTable.pinnedColumn'),
    meta: { flex: 1 },
  },
]

export const TIMELINE_ACTION_COLUMNS: ColumnDef<GETAction>[] = [
  {
    accessorKey: 'code',
    header: i18next.t('viewActionsTable.id'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'title',
    header: i18next.t('viewActionsTable.title'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'eventCode',
    header: i18next.t('viewActionsTable.eventCode'),
    meta: { flex: 1 },
  },
  {
    accessorKey: 'actionCode',
    header: i18next.t('viewActionsTable.actionCode'),
    meta: { flex: 1 },
  },
]

export enum TIMELINE_CONFIG_STEPS {
  GENERAL = 'General',
  OBJECT_Y = 'Object Y',
  OBJECT_X = 'Object X',
}

export const TIMELINE_GENERAL_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = [
  'code',
  'title',
  'mode',
]
export const TIMELINE_OBJECT_Y_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = ['objectY']
export const TIMELINE_OBJECT_X_FORM_FIELD_KEYS: Array<FieldPath<TimeLineGridConfig>> = ['objectX']

export const TIMELINE_FORM_STEP_FIELDS: Record<number, Array<FieldPath<TimeLineGridConfig>>> = {
  0: TIMELINE_GENERAL_FORM_FIELD_KEYS,
  1: TIMELINE_OBJECT_Y_FORM_FIELD_KEYS,
  2: TIMELINE_OBJECT_X_FORM_FIELD_KEYS,
}

export const MAIN_OBJECT_TYPE_X = 'X'
export const MAIN_OBJECT_TYPE_Y = 'Y'

export const MAIN_OBJECT_RADIO_OPTIONS: RadioOption[] = [
  {
    value: MAIN_OBJECT_TYPE_Y,
    label: 'Y',
  },
  {
    value: MAIN_OBJECT_TYPE_X,
    label: 'X',
  },
]

export const TIME_LINE_INFINITE_SCROLL_Y_PAGINATION_SIZE = '40'
export const TIME_LINE_PAGINATION_SIZE = '1000'

export const TIME_LINE_WEEKEND_HEADER_CLASS_NAME = 'time_line_weekend_header'
export const TIME_LINE_DATE_INTERVAL_CELL_CLASS_NAME = 'time_line_date_interval_cell_style'
export const TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME =
  'time_line_date_interval_cell_jsx_parser_style'

export const TIME_LINE_CELL_MAX_ITEMS_COUNT = 4

export const SELECTED_CELL_STYLE = {
  backgroundColor: 'rgba(0, 0, 0, 0.2)',
  filter: 'brightness(0.8)',
}

export const TIME_LINE_SLIDER_STEP = 1

export const TIME_LINE_OBJECT_X_CELL_MIN_WIDTH = 70
export const TIME_LINE_OBJECT_X_CELL_MAX_WIDTH = 500

export const TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT = 50
export const TIME_LINE_OBJECT_X_CELL_MAX_HEIGHT = 250

export const TIME_LINE_OBJECT_X_CELL_DEFAULT_PREVIEW_COLUMNS_COUNT = 5
export const TIME_LINE_OBJECT_X_CELL_MAX_PREVIEW_COLUMNS_COUNT = 10
export const TIME_LINE_OBJECT_X_CELL_MIN_PREVIEW_COLUMNS_COUNT = 1
export const TIME_LINE_OBJECT_X_CELL_MAX_PREVIEW_ROWS_COUNT = 10
export const TIME_LINE_OBJECT_X_CELL_MIN_PREVIEW_ROWS_COUNT = 1
export const TIME_LINE_OBJECT_X_CELL_DEFAULT_PREVIEW_ROWS_COUNT = 3

export const TIME_LINE_DEFAULT_TIME_INTERVAL_INCREMENT = INCREMENT_TYPE.DAY
export const TIME_LINE_DEFAULT_TIME_INTERVAL_SHOW_FILTER = false
export const TIME_LINE_DEFAULT_MODE = TIME_LINE_MODE.DATE_TIME

export const TIMELINE_CELL_DATA_ATTR = 'data-cell-id'

export const TIME_LINE_OBJECT_X_CELL_DRAG_SOURCE_CLASS_NAME = 'timeline-source-cell-animated'

export const TIME_LINE_OBJECT_X_CELL_DRAG_SOURCE_STYLE = {
  '@keyframes tlSourceDashMove': {
    to: {
      backgroundPosition: '12px 0, -12px 100%, 0 -12px, 100% 12px',
    },
  },
  '.timeline-source-cell-animated': {
    position: 'relative',
    opacity: 0.6,
  },
  '.timeline-source-cell-animated::after': {
    content: '""',
    position: 'absolute',
    pointerEvents: 'none',
    inset: 0,
    backgroundImage: [
      'repeating-linear-gradient(90deg, #6B7280 0 6px, transparent 6px 12px)',
      'repeating-linear-gradient(90deg, #6B7280 0 6px, transparent 6px 12px)',
      'repeating-linear-gradient(0deg, #6B7280 0 6px, transparent 6px 12px)',
      'repeating-linear-gradient(0deg, #6B7280 0 6px, transparent 6px 12px)',
    ].join(','),
    backgroundSize: '100% 2px, 100% 2px, 2px 100%, 2px 100%',
    backgroundPosition: '0 0, 0 100%, 0 0, 100% 0',
    backgroundRepeat: 'no-repeat',
    animation: 'tlSourceDashMove 0.7s linear infinite',
  },
}

export const TIME_LINE_OBJECT_X_CELL_DRAG_TARGET_CLASS_NAME = 'timeline-drag-target-cell'
export const TIME_LINE_OBJECT_X_CELL_DRAG_TARGET_STYLE = {
  [`.${TIME_LINE_OBJECT_X_CELL_DRAG_TARGET_CLASS_NAME}`]: {
    position: 'relative',
    isolation: 'isolate',
  },
  [`.${TIME_LINE_OBJECT_X_CELL_DRAG_TARGET_CLASS_NAME}::after`]: {
    content: '""',
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 10,
    boxSizing: 'border-box',
    border: '1.5px solid #43a047', // мягче, чем #4caf50
    backgroundColor: 'rgba(67, 160, 71, 0.08)', // легче заливка
    boxShadow: 'inset 0 0 0 1px rgba(67,160,71,.22), 0 0 0 1px rgba(67,160,71,.12)',
    borderRadius: '2px',
  },
}
